import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  type CarrierLogisticsCredType,
  carrierLogistics,
} from '../standards.js'

export type sfclCredType = CarrierLogisticsCredType
export const sfclDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const sfcl: CarrierDef<sfclCredType> = {
  name: 'Specialized Freight Carriers',
  scac: 'sfcl',
  ...carrierLogistics,
  engineLayers: ['documents', 'pickup', 'rating', 'tracking'],
  documentTypes: sfclDocumentTypes,
}
